import styles from './AuditedFinancials.module.scss';
import { useAuditedReportDownload } from './useAuditedReportDownload';
import LoadingSpinner from '../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import FileViewerDrawer from '../../../../common/DocumentViewer/FileViewerDrawer';
import { ctaPurpleRight } from '../../../../assets/hostedassets';

interface AuditedFinancialsProps {
    assesseeOrgId: string;
    companyName?: string;
}

function AuditedFinancials({ assesseeOrgId, companyName = '' }: AuditedFinancialsProps) {
    const { downloading, viewLoading, viewerState, onViewClick, onDownloadClick, closeViewer } = useAuditedReportDownload({
        assesseeOrgId,
        orgName: companyName,
    });

    return (
        <>
            <button type="button" className={styles.DownloadControl} onClick={onViewClick} disabled={viewLoading} aria-label="View">
                {viewLoading ? (
                    <LoadingSpinner height="16px" color="#6021b3" style={{ margin: 0 }} />
                ) : (
                    <img src={ctaPurpleRight} alt="" width={14} height={14} />
                )}
                <span>Raw Data</span>
            </button>
            {!!viewerState && (
                <FileViewerDrawer
                    heading={`Audited Financials — ${companyName || 'Report'}`}
                    fileUrl={viewerState.url}
                    mimeType={viewerState.mimeType}
                    downloading={downloading}
                    downloadLabel="Download"
                    onDownload={onDownloadClick}
                    onClose={closeViewer}
                />
            )}
        </>
    );
}

export default AuditedFinancials;
